import React from 'react';
import {Card} from 'semantic-ui-react';

import './index.css';

export class ChatedCard extends React.Component {
	render() {
		let text = <div className="chated-card-text" style={{color: this.props.color}}>{ this.props.text }</div>;
		let subText = <br />;

		if (this.props.subtext) {
			subText = <div className="chated-card-subtext" style={{color: this.props.subcolor}}>{ this.props.subtext }</div>;
		} else {
			text = <div className="chated-card-text-no-subtext" style={{color: this.props.color}}>{ this.props.text }</div>;
		}

		return (
			<Card raised className="center uppercase chated-card">
				<Card.Header className="chated-card-header-text">
					{this.props.title}
				</Card.Header>
				<Card.Content className="chated-card-content">
					{ text }
					{ subText }
				</Card.Content>
			</Card>
		);
	}
}

export default ChatedCard;



// WEBPACK FOOTER //
// ./src/components/card/index.js